




















































import {Vue, Component} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import StatisticalReportDTO from "@/dto/archive/StatisticalReportDTO";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import DocumentService from "@/services/DocumentService";
import {processError} from "@/utils/ComponentUtils";
import CreateStatisticalReportPayload from "@/dto/archive/CreateStatisticalReportPayload";
import CreateStatisticalReportModal from "@/components/documents/CreateStatisticalReportModal.vue";


const AppModule = namespace("App");

@Component({
  components: {PaginationComponent}
})
export default class StatisticalReportList extends Vue {

  @AppModule.Action private startLoading!: () => void;
  @AppModule.Action private stopLoading!: () => void;

  reports: Array<StatisticalReportDTO> = [];
  totalPages = 1;
  pageNumber = 1;

  createPayload = new CreateStatisticalReportPayload();

  mounted(){
    this.loadReports();
  }


  loadReports(){
    this.startLoading();
    DocumentService.getStatisticalReports(this.pageNumber, 20).then(
        ok => {
          this.reports = ok.data.content;
          this.totalPages = ok.data.totalPages;
          this.stopLoading();
        },
        err => {
          this.stopLoading();
          processError(err, this);
        }
    )
  }

  changePage(page: number) {
    this.pageNumber = page;
    this.loadReports();
  }

  newReport(){
    this.$modal.show(
        CreateStatisticalReportModal,
        {
          onSaved: () => this.reset()
        }
    )
  }

  reset(){
    this.totalPages = 1;
    this.pageNumber = 1;
    this.loadReports();
  }




}
